/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// clang-format off
export {
  ÉµÉµattribute,
  ÉµÉµattributeInterpolate1,
  ÉµÉµattributeInterpolate2,
  ÉµÉµattributeInterpolate3,
  ÉµÉµattributeInterpolate4,
  ÉµÉµattributeInterpolate5,
  ÉµÉµattributeInterpolate6,
  ÉµÉµattributeInterpolate7,
  ÉµÉµattributeInterpolate8,
  ÉµÉµattributeInterpolateV,
  ÉµÉµdefineComponent,
  ÉµÉµdefineDirective,
  ÉµÉµdefinePipe,
  ÉµÉµdefineNgModule,
  detectChanges as ÉµdetectChanges,
  renderComponent as ÉµrenderComponent,
  AttributeMarker as ÉµAttributeMarker,
  ComponentType as ÉµComponentType,
  ComponentFactory as ÉµRender3ComponentFactory,
  ComponentRef as ÉµRender3ComponentRef,
  DirectiveType as ÉµDirectiveType,
  RenderFlags as ÉµRenderFlags,
  ÉµÉµdirectiveInject,
  ÉµÉµinjectAttribute,
  ÉµÉµinjectPipeChangeDetectorRef,
  ÉµÉµinvalidFactory,
  ÉµÉµgetFactoryOf,
  ÉµÉµgetInheritedFactory,
  ÉµÉµsetComponentScope,
  ÉµÉµsetNgModuleScope,
  ÉµÉµtemplateRefExtractor,
  ÉµÉµProvidersFeature,
  ÉµÉµCopyDefinitionFeature,
  ÉµÉµInheritDefinitionFeature,
  ÉµÉµNgOnChangesFeature,
  LifecycleHooksFeature as ÉµLifecycleHooksFeature,
  NgModuleType as ÉµNgModuleType,
  NgModuleRef as ÉµRender3NgModuleRef,
  CssSelectorList as ÉµCssSelectorList,
  markDirty as ÉµmarkDirty,
  NgModuleFactory as ÉµNgModuleFactory,
  NO_CHANGE as ÉµNO_CHANGE,
  ÉµÉµcontainer,
  ÉµÉµnextContext,
  ÉµÉµelementStart,
  ÉµÉµnamespaceHTML,
  ÉµÉµnamespaceMathML,
  ÉµÉµnamespaceSVG,
  ÉµÉµelement,
  ÉµÉµlistener,
  ÉµÉµtext,
  ÉµÉµtextInterpolate,
  ÉµÉµtextInterpolate1,
  ÉµÉµtextInterpolate2,
  ÉµÉµtextInterpolate3,
  ÉµÉµtextInterpolate4,
  ÉµÉµtextInterpolate5,
  ÉµÉµtextInterpolate6,
  ÉµÉµtextInterpolate7,
  ÉµÉµtextInterpolate8,
  ÉµÉµtextInterpolateV,
  ÉµÉµembeddedViewStart,
  ÉµÉµprojection,
  ÉµÉµpipeBind1,
  ÉµÉµpipeBind2,
  ÉµÉµpipeBind3,
  ÉµÉµpipeBind4,
  ÉµÉµpipeBindV,
  ÉµÉµpureFunction0,
  ÉµÉµpureFunction1,
  ÉµÉµpureFunction2,
  ÉµÉµpureFunction3,
  ÉµÉµpureFunction4,
  ÉµÉµpureFunction5,
  ÉµÉµpureFunction6,
  ÉµÉµpureFunction7,
  ÉµÉµpureFunction8,
  ÉµÉµpureFunctionV,
  ÉµÉµgetCurrentView,
  getDirectives as ÉµgetDirectives,
  getHostElement as ÉµgetHostElement,
  ÉµÉµrestoreView,
  ÉµÉµcontainerRefreshStart,
  ÉµÉµcontainerRefreshEnd,
  ÉµÉµqueryRefresh,
  ÉµÉµviewQuery,
  ÉµÉµstaticViewQuery,
  ÉµÉµstaticContentQuery,
  ÉµÉµcontentQuery,
  ÉµÉµloadQuery,
  ÉµÉµelementEnd,
  ÉµÉµhostProperty,
  ÉµÉµproperty,
  ÉµÉµpropertyInterpolate,
  ÉµÉµpropertyInterpolate1,
  ÉµÉµpropertyInterpolate2,
  ÉµÉµpropertyInterpolate3,
  ÉµÉµpropertyInterpolate4,
  ÉµÉµpropertyInterpolate5,
  ÉµÉµpropertyInterpolate6,
  ÉµÉµpropertyInterpolate7,
  ÉµÉµpropertyInterpolate8,
  ÉµÉµpropertyInterpolateV,
  ÉµÉµupdateSyntheticHostBinding,
  ÉµÉµcomponentHostSyntheticListener,
  ÉµÉµprojectionDef,
  ÉµÉµreference,
  ÉµÉµenableBindings,
  ÉµÉµdisableBindings,
  ÉµÉµelementContainerStart,
  ÉµÉµelementContainerEnd,
  ÉµÉµelementContainer,
  ÉµÉµstyleMap,
  ÉµÉµstyleSanitizer,
  ÉµÉµclassMap,
  ÉµÉµclassMapInterpolate1,
  ÉµÉµclassMapInterpolate2,
  ÉµÉµclassMapInterpolate3,
  ÉµÉµclassMapInterpolate4,
  ÉµÉµclassMapInterpolate5,
  ÉµÉµclassMapInterpolate6,
  ÉµÉµclassMapInterpolate7,
  ÉµÉµclassMapInterpolate8,
  ÉµÉµclassMapInterpolateV,
  ÉµÉµstyleProp,
  ÉµÉµstylePropInterpolate1,
  ÉµÉµstylePropInterpolate2,
  ÉµÉµstylePropInterpolate3,
  ÉµÉµstylePropInterpolate4,
  ÉµÉµstylePropInterpolate5,
  ÉµÉµstylePropInterpolate6,
  ÉµÉµstylePropInterpolate7,
  ÉµÉµstylePropInterpolate8,
  ÉµÉµstylePropInterpolateV,
  ÉµÉµclassProp,

  ÉµÉµselect,
  ÉµÉµadvance,
  ÉµÉµtemplate,
  ÉµÉµembeddedViewEnd,
  store as Éµstore,
  ÉµÉµpipe,
  ComponentDef as ÉµComponentDef,
  ÉµÉµComponentDefWithMeta,
  ÉµÉµFactoryDef,
  DirectiveDef as ÉµDirectiveDef,
  ÉµÉµDirectiveDefWithMeta,
  PipeDef as ÉµPipeDef,
  ÉµÉµPipeDefWithMeta,
  whenRendered as ÉµwhenRendered,
  ÉµÉµi18n,
  ÉµÉµi18nAttributes,
  ÉµÉµi18nExp,
  ÉµÉµi18nStart,
  ÉµÉµi18nEnd,
  ÉµÉµi18nApply,
  ÉµÉµi18nPostprocess,
  setLocaleId as ÉµsetLocaleId,
  setClassMetadata as ÉµsetClassMetadata,
  ÉµÉµresolveWindow,
  ÉµÉµresolveDocument,
  ÉµÉµresolveBody,
} from './render3/index';


export {
  compileComponent as ÉµcompileComponent,
  compileDirective as ÉµcompileDirective,
} from './render3/jit/directive';
export {
  compileNgModule as ÉµcompileNgModule,
  compileNgModuleDefs as ÉµcompileNgModuleDefs,
  patchComponentDefWithScope as ÉµpatchComponentDefWithScope,
  resetCompiledComponents as ÉµresetCompiledComponents,
  flushModuleScopingQueueAsMuchAsPossible as ÉµflushModuleScopingQueueAsMuchAsPossible,
  transitiveScopesFor as ÉµtransitiveScopesFor,
} from './render3/jit/module';
export {
  compilePipe as ÉµcompilePipe,
} from './render3/jit/pipe';

export {
  NgModuleDef as ÉµNgModuleDef,
  ÉµÉµNgModuleDefWithMeta,
  NgModuleTransitiveScopes as ÉµNgModuleTransitiveScopes,
} from './metadata/ng_module';

export {
  ÉµÉµsanitizeHtml,
  ÉµÉµsanitizeStyle,
  ÉµÉµdefaultStyleSanitizer,
  ÉµÉµsanitizeScript,
  ÉµÉµsanitizeUrl,
  ÉµÉµsanitizeResourceUrl,
  ÉµÉµsanitizeUrlOrResourceUrl,
} from './sanitization/sanitization';

export {
  bypassSanitizationTrustHtml as ÉµbypassSanitizationTrustHtml,
  bypassSanitizationTrustStyle as ÉµbypassSanitizationTrustStyle,
  bypassSanitizationTrustScript as ÉµbypassSanitizationTrustScript,
  bypassSanitizationTrustUrl as ÉµbypassSanitizationTrustUrl,
  bypassSanitizationTrustResourceUrl as ÉµbypassSanitizationTrustResourceUrl,
} from './sanitization/bypass';

export {
  getLContext as ÉµgetLContext
} from './render3/context_discovery';

export {
  NG_ELEMENT_ID as ÉµNG_ELEMENT_ID,
  NG_COMP_DEF as ÉµNG_COMP_DEF,
  NG_DIR_DEF as ÉµNG_DIR_DEF,
  NG_PIPE_DEF as ÉµNG_PIPE_DEF,
  NG_MOD_DEF as ÉµNG_MOD_DEF,
} from './render3/fields';

export {
  NG_PROV_DEF as ÉµNG_PROV_DEF,
  NG_INJ_DEF as ÉµNG_INJ_DEF,
} from './di/interface/defs';

export {
  Player as ÉµPlayer,
  PlayerFactory as ÉµPlayerFactory,
  PlayState as ÉµPlayState,
  PlayerHandler as ÉµPlayerHandler,
} from './render3/interfaces/player';

export {
  LContext as ÉµLContext,
} from './render3/interfaces/context';

export {
  setDocument as ÉµsetDocument
} from './render3/interfaces/document';

// we reexport these symbols just so that they are retained during the dead code elimination
// performed by rollup while it's creating fesm files.
//
// no code actually imports these symbols from the @angular/core entry point
export {
  compileNgModuleFactory__POST_R3__ as ÉµcompileNgModuleFactory__POST_R3__,
  isBoundToModule__POST_R3__ as ÉµisBoundToModule__POST_R3__
} from './application_ref';
export {
  SWITCH_COMPILE_COMPONENT__POST_R3__ as ÉµSWITCH_COMPILE_COMPONENT__POST_R3__,
  SWITCH_COMPILE_DIRECTIVE__POST_R3__ as ÉµSWITCH_COMPILE_DIRECTIVE__POST_R3__,
  SWITCH_COMPILE_PIPE__POST_R3__ as ÉµSWITCH_COMPILE_PIPE__POST_R3__,
} from './metadata/directives';
export {
  SWITCH_COMPILE_NGMODULE__POST_R3__ as ÉµSWITCH_COMPILE_NGMODULE__POST_R3__,
} from './metadata/ng_module';
export {
  getDebugNode__POST_R3__ as ÉµgetDebugNode__POST_R3__,
} from './debug/debug_node';
export {
  SWITCH_COMPILE_INJECTABLE__POST_R3__ as ÉµSWITCH_COMPILE_INJECTABLE__POST_R3__,
} from './di/injectable';
export {
  SWITCH_IVY_ENABLED__POST_R3__ as ÉµSWITCH_IVY_ENABLED__POST_R3__,
} from './ivy_switch';
export {
  SWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__ as ÉµSWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__,
} from './change_detection/change_detector_ref';
export {
  Compiler_compileModuleSync__POST_R3__ as ÉµCompiler_compileModuleSync__POST_R3__,
  Compiler_compileModuleAsync__POST_R3__ as ÉµCompiler_compileModuleAsync__POST_R3__,
  Compiler_compileModuleAndAllComponentsSync__POST_R3__ as ÉµCompiler_compileModuleAndAllComponentsSync__POST_R3__,
  Compiler_compileModuleAndAllComponentsAsync__POST_R3__ as ÉµCompiler_compileModuleAndAllComponentsAsync__POST_R3__,
} from './linker/compiler';
export {
  SWITCH_ELEMENT_REF_FACTORY__POST_R3__ as ÉµSWITCH_ELEMENT_REF_FACTORY__POST_R3__,
} from './linker/element_ref';
export {
  SWITCH_TEMPLATE_REF_FACTORY__POST_R3__ as ÉµSWITCH_TEMPLATE_REF_FACTORY__POST_R3__,
} from './linker/template_ref';
export {
  SWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__ as ÉµSWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__,
} from './linker/view_container_ref';
export {
  SWITCH_RENDERER2_FACTORY__POST_R3__ as ÉµSWITCH_RENDERER2_FACTORY__POST_R3__,
} from './render/api';

export { getModuleFactory__POST_R3__ as ÉµgetModuleFactory__POST_R3__ } from './linker/ng_module_factory_loader';

export { registerNgModuleType as ÉµregisterNgModuleType } from './linker/ng_module_factory_registration';

export {
  publishGlobalUtil as ÉµpublishGlobalUtil,
  publishDefaultGlobalUtils as ÉµpublishDefaultGlobalUtils
} from './render3/util/global_utils';

export {createInjector as ÉµcreateInjector} from './di/r3_injector';

export {INJECTOR_IMPL__POST_R3__ as ÉµINJECTOR_IMPL__POST_R3__} from './di/injector';

// clang-format on
